<h4 class="flex items-center gap-2 font-semibold">
  <i [class]="icon()"></i>
  {{ titleKey() | transloco }}
</h4>
@for (item of items(); track item.scNumber) {
  <div class="flex flex-col gap-1 text-sm">
    <div class="flex items-center justify-between gap-3">
      <span class="flex flex-col">
        <span>{{ item.label }}</span>
        <span class="text-muted-color text-xs">{{ item.criterionLabel }}</span>
      </span>
      <span class="font-semibold whitespace-nowrap"
        >{{ item.percentage | appNumber: '1.0-0' }} %</span
      >
    </div>
    <app-score-bar [percentage]="item.percentage ?? 0" />
  </div>
} @empty {
  <span class="text-muted-color text-sm">{{
    'project.steps.providerResults.rfpIndividual.noHighlights' | transloco
  }}</span>
}
